import { Injectable } from '@angular/core';
import { CacheHouse } from './cachehouse.interface';

@Injectable({ providedIn: 'root' })
export class CacheHouseIndexDB implements CacheHouse {
  pendings: any = {};
  store: any = null;

  constructor() {
    if (!window.indexedDB) {
      console.log(`Your browser doesn't support IndexedDB`);
      return;
    }
    const request = indexedDB.open('flecx', 1);
    request.onerror = (event: any) => {
      console.error(`Database error: ${event.target.errorCode}`);
    };

    request.onupgradeneeded = (event) => {
      const db = request.result;
      db.createObjectStore('analytics', { keyPath: 'id' });

      console.log(new Date().toLocaleString() + '  ➤  Schema created successfully');
    };

    request.onsuccess = (event) => {
      console.log(new Date().toLocaleString() + '  ➤  Database opened successfully');

      Object.keys(this.pendings).forEach((key) => {
        this.setItem(key, this.pendings[key]);
      });
    };

    this.store = request;
  }

  setItem(key: string, value: any) {
    return new Promise((resolve, reject) => {
      if (this.store.readyState == 'pending') {
        this.pendings[key] = value;
        resolve(true);
      }

      const db = this.store.result;
      const transaction = db.transaction('analytics', 'readwrite');
      const query = transaction.objectStore('analytics');

      const result = query.put({ id: key || Date.now(), ...Object.assign({}, value) });

      result.onerror = (error: any) => {
        reject(error);
      };

      result.onsuccess = (event: any) => {
        resolve(true);
      };
    });
  }

  getItem(key: string) {
    return new Promise((resolve, reject) => {
      const db = this.store.result;
      const transaction = db.transaction('analytics', 'readwrite');
      const query = transaction.objectStore('analytics');

      const result = query.get(key);

      result.onerror = (error: any) => {
        reject(error);
      };

      result.onsuccess = (event: any) => {
        resolve(event.target.result);
      };
    });
  }

  removeItem(key: string) {
    const db = this.store.result;
    const transaction = db.transaction('analytics', 'readwrite');
    const query = transaction.objectStore('analytics');
    query.delete(key);
    return true;
  }

  getAll() {
    return new Promise((resolve, reject) => {
      const db = this.store.result;
      const transaction = db.transaction('analytics', 'readwrite');
      const query = transaction.objectStore('analytics');
      const result = query.getAll();

      result.onerror = (error: any) => {
        reject(error);
      };

      result.onsuccess = (event: any) => {
        resolve(event.target.result);
      };
    });
  }
}
